/* Pre-order ship estimate on the 2026 PDP. Figma 278:915.

   The Globo pre-order app injects its own message blocks client-side --
   .gPreorderTopMessage carries the date ("Expected to Ship by Oct 27, 2026"),
   .gPreorderBottomMessage the longer copy. The design wants that information as
   a status row above the button, in the same shape as the sold-out row but in
   amber.

   The text is taken from the app rather than recomputed: the wording and the
   date are configured there, so re-deriving them would mean two sources that
   drift apart. The app's own blocks are then hidden, since they carry its
   styling rather than the design's. */
(function () {
  const SOURCE = '.gPreorderTopMessage';
  const HIDE = ['.gPreorderTopMessage', '.gPreorderBottomMessage'];

  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* The design reads "Est. ships week of Oct 3", while the app's message is
     whatever the merchant configured around its :shipping_date token --
     currently "In High Demand: Expected to Ship by Oct 27, 2026". Pull the date
     out and restate it in the design's words.

     The date is shown exactly as the app has it. Rounding back to the Monday of
     that week was tempting for the "week of" wording, but it moves the date
     earlier -- Oct 27 would read as "week of Oct 26" -- and a pre-order promise
     should never appear sooner than the app states. If no date can be found the
     app's own message is shown unchanged rather than hiding the row. */
  function shipWeekOf(message) {
    const match = message.match(/\b([A-Z][a-z]{2})[a-z]*\.?\s+(\d{1,2})(?:[a-z]{2})?(?:,?\s*(\d{4}))?/);
    if (!match) return '';
    const month = MONTHS.indexOf(match[1]);
    if (month < 0) return '';
    const day = parseInt(match[2], 10);
    const year = match[3] ? parseInt(match[3], 10) : new Date().getFullYear();
    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) return '';
    return MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  function apply() {
    const row = document.querySelector('[data-pdp2026-preorder-status]');
    const text = row && row.querySelector('[data-pdp2026-preorder-text]');
    if (!row || !text) return false;

    const source = document.querySelector(SOURCE);
    const message = source ? source.textContent.trim().replace(/\s+/g, ' ') : '';

    if (!message) {
      row.setAttribute('hidden', '');
      return false;
    }

    const week = shipWeekOf(message);
    const prefix = row.dataset.prefix || 'Est. ships week of';
    const label = week ? prefix + ' ' + week : message;

    if (text.textContent !== label) text.textContent = label;
    row.removeAttribute('hidden');

    HIDE.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.style.display = 'none';
      });
    });
    return true;
  }

  function watch() {
    apply();
    // The app renders after us and re-renders on a variant change, so keep
    // watching rather than polling for a fixed window.
    const host = document.querySelector('.main-product-section') || document.body;
    new MutationObserver(() => apply()).observe(host, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
